<template>
  <b-container fluid>
    <div class="row">
      <div class="col-md-12">
        <h5 class="text-muted">Client: </h5>
        <div class="col-md-12">
          <a class="list-group-item list-group-item-action" aria-current="true">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Commande #{{ order.reference }}</h5>
              <small>
                <paiement-tag :payment="order.statusPaid" />
                <state-tag :state="order.state" />
              </small>
            </div>

            <div class="small" v-if="order.client">
              <i class="fa fa-user mr-2" aria-hidden="true"></i>{{ order.client.firstname }} {{ order.client.lastname }} |
              <i class="fa fa-envelope-o mr-2" aria-hidden="true"></i>{{ order.client.email }}  |
              <i class="fa fa-phone mr-2" aria-hidden="true"></i>{{ order.client.phone }} 
            </div>

            <p class="mb-1">
              <i class="fa fa-calendar" aria-hidden="true"></i>&nbsp;
              <span class="text-muted">{{ order.createdAt | formatDateShort }}</span> |
              <i class="fa fa-hand-paper-o" aria-hidden="true"></i> &nbsp;
              <span class="text-muted" v-if="order.deliverMode === 0">Récupérer le plus tôt possible</span>
              <span class="text-muted" v-if="order.deliverMode === 1">
                Récupérer le
                <span v-if="order.deliverDate !== null">{{ order.deliverDate| formatDateShort }}</span>
              </span> |
              <i class="fa fa-credit-card" aria-hidden="true"></i> &nbsp;
              <span class="text-muted" v-if="order.paymentType === 0">Au retrait</span>
              <span class="text-muted" v-if="order.paymentType === 1">Carte bancaire</span>
            </p>
            <p class="mb-1" v-show="order.comment">
              <span class="text-muted font-weight-bold mx-1">Commentaire :</span>
                <span class="text-muted" >{{ order.comment }}</span>
            </p>

            <div class="d-flex justify-content-end">
              
              <b-button data-cy="refund_total" @click="$refs['modal-1'].show()" class="mr-2" size="sm" :disabled="order.statusPaid !== 1">Remboursement total</b-button>
              <b-modal id="modal-1" ref="modal-1" hide-footer title="Confirmation">
                <div class="row d-flex justify-content-center">
                  <div class="col-md-12 my-4 text-center">
                    <span>Êtes-vous sûr de vouloir rembourser l'intégralité de la commande ?</span>
                  </div>
                  <div class="col-md-5">
                    <b-button data-cy="submit_refund_total" class="mt-3" variant="outline-success" block @click="refundTotal(order)">Oui</b-button>
                  </div>
                  <div class="col-md-5">
                    <b-button class="mt-3" variant="outline-danger" block @click="$refs['modal-1'].hide()">Non</b-button>
                  </div>
                </div>
              </b-modal>


              <!---@Todo: Composant -->
              <b-button data-cy="refund_partial" @click="$refs['modal-2'].show()" size="sm" :disabled="order.statusPaid !== 1">Remboursement partiel</b-button>
              <b-modal ref="modal-2" hide-footer title="Confirmation">
                <div class="row d-flex justify-content-center">
                  <div class="col-md-12">
                    <p class="text-center my-4">Saisissez la somme à rembourser</p>
                    <text-field
                      name="Montant"
                      type="number"
                      property="amoutPartial"
                      v-model.number="amoutPartial"
                    />
                  </div>
                  <div class="col-md-5">
                    <b-button class="mt-3" variant="outline-success" block data-cy="submit_refund_partial" @click="refundPartial(order.id, order.total)">Rembourser</b-button>
                  </div>
                  <div class="col-md-5">
                    <b-button class="mt-3" variant="outline-danger" block @click="$refs['modal-2'].hide()">Annuler</b-button>
                  </div>
                </div>
                
              </b-modal>
  
            </div>
            
          </a>
        </div>
        
        <h5 class="text-muted">Produit(s) commande: </h5>
        <ul class="list-group">
          <li v-for="item in order.orderItems" :key="item.id"
              class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
              <div class="fw-bold">
                {{ item.name }}
                <span class="badge bg-primary rounded-pill">x {{ item.qty }}</span>
              </div>
              <i class="text-lowercase small">{{ item.category }}</i>
            </div>
            <div class="ms-2 me-auto" v-if="item.category === 'menu'">
                <span class="small" v-for="product in item.products" :key="product.name">
                  <b>{{ product.name }} </b> (<i class="text-lowercase">{{ product.cat }} </i>)
                  x {{ product.qty }} 
                  <small v-if="product.price">- Supplément +{{ product.price * product.qty }} €</small> 
                  <br> 
                </span>
            </div>
            <span class="badge bg-primary rounded-pill">{{ item.price | numberWithCommas }}</span>
          </li>
        </ul>

        <h5 class="text-muted mt-5">Commentaire(s): </h5>
        <b-card class="m-auto">
          <div class="row mt-2" v-for="(comment) in order.commentsOrder" :key="comment.id">
            <div class="col-md-2 text-end">
              <b-avatar variant="info" src="https://placekitten.com/300/300" size="3rem"></b-avatar>
            </div>
            <div class="col-md-10 px-3">
              <div class="row mb-1">
                <div class="col-md-6 text-start pl-0">
                  {{  comment.author  }}
                </div>
                <div class="col-md-6 text-end">
                  <small class="text-muted">{{ comment.createdAt | interval }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 comment-background p-2 m-0">
                  {{ comment.message }}
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </b-container>
</template>

<script>
import {mapState, mapActions} from "vuex";
import {TextField} from "@/core/components/form";
import StateTag from "@/modules/order/components/StateTag";
import PaiementTag from "@/modules/order/components/PaiementTag";

export default {
  name: 'Orders',
  components:{
    TextField,
    StateTag,
    PaiementTag
  },
  data(){
    return {
      showConfirmationRefund: false,
      showConfirmationRefundPartial: false,
      amoutPartial: 0
    }
  },
  computed: {
    ...mapState('auth',['fullUser']),
    ...mapState('orders',['order','apiRslt'])
  },
  created() {
    this.getOneOrder(this.$route.params.id)
  },
  methods: {
    ...mapActions('notifications',['send']),
    ...mapActions('orders', ['getOneOrder','refund','partialRefund']),
    refundTotal(order){
        this.refund(order)
        this.$refs['modal-1'].hide()
    },
    refundPartial(order,total){
      if(this.amoutPartial < total && this.amoutPartial !== 0){
         this.partialRefund({ user: this.fullUser.username, order: order, amount: this.amoutPartial })
       }
    }
  },
}
</script>
<style>
thead > tr > th {
  padding: 1.3rem !important;
}
tbody > tr > td {
  padding: 1.3rem !important;
}
ul {
  list-style-type: none;
}
</style>
